<form [formGroup]="inputForm" *ngIf="inputForm">
  <section>
    <h3>Bankverbindung</h3>
    <app-get-iban *ngIf="inputForm" [inputForm]="inputForm.get('bankAccount')"></app-get-iban>
  </section>
  <section>
    <h3>Zahlungsart</h3>
    <div *ngIf="!(feederContractConfig$ | async).sepaActivated">Überweisung</div>
    <mat-radio-group
      *ngIf="(feederContractConfig$ | async).sepaActivated"
      class="radio-group"
      fxLayout="row"
      fxLayoutGap="2em"
      formControlName="paymentType"
      (change)="changePaymentType($event)">
      <mat-radio-button class="radio-button" [value]="paymentTypeEnum.DIRECTDEBIT">
        SEPA-Lastschriftmandat
      </mat-radio-button>
      <mat-radio-button class="radio-button" [value]="paymentTypeEnum.BANKTRANSFER">
        Überweisung
      </mat-radio-button>
    </mat-radio-group>
    <div style="margin-top: 1rem">
      <mat-error *ngIf="!inputForm.get('paymentType').valid && inputForm.get('paymentType').touched">
        Bitte wählen Sie die Zahlungsart aus
      </mat-error>
    </div>
  </section>

  <section
    *ngIf="inputForm.get('paymentType') && inputForm.get('paymentType').value == paymentTypeEnum.DIRECTDEBIT">
    <h3>Erteilung eines SEPA Lastschriftmandats</h3>
    <p>
      Der Netzbetreiber überweist die Vergütungen auf das oben angegebene Konto und ist bis auf Widerruf
      berechtigt, Überzahlungen vom oben genannten Konto abbuchen zu lassen.
    </p>
    <p>
      SEPA-Lastschriftmandat: Der Anlagenbetreiber ermächtigt den Netzbetreiber, Zahlungen vom Konto des
      Anlagenbetreibers mittels Lastschrift einzuziehen. Der Anlagenbetreiber weist sein Kreditinstitut an,
      die vom Netzbetreiber auf das Konto des Anlagenbetreibers gezogenen Lastschriften einzulösen.
    </p>
    <p>
      Hinweis: Der Anlagenbetreiber kann innerhalb von acht Wochen, beginnend mit dem Belastungsdatum, die
      Erstattung des belasteten Betrags verlangen. Es gelten dabei die vom Anlagenbetreiber mit seinem
      Kreditinstitut vereinbarten Bedingungen. Vor dem ersten Einzug einer SEPA-Basislastschrift wird der
      Anlagenbetreiber vom Netzbetreiber über den Einzug in dieser Verfahrensart unterrichtet.
    </p>

    <form-row>
      <app-accept-conditions
        (changeAccepted)="changeSepaConditions($event)"
        [inputForm]="inputForm.get('sepaMandate')"
        [controlName]="'acceptedSepa'"
        [disable]="!canUpdate"
        [inputLink]=""
        [inputText]="
          'Ich/Wir ermächtige(n), Zahlungen von meinem/unserem Konto mittels Lastschrift einzuziehen. Zugleich weise(n) ich/wir mein/unser Kreditinstitut an, die vom Netzbetreiber auf mein/unser Konto gezogenen Lastschriften einzulösen.'
        "></app-accept-conditions>
    </form-row>
    <section>
      <p
        style="margin-top: 1rem; font-weight: bold"
        *ngIf="inputForm.get('sepaMandate').get('sepaAcceptedDate').value">
        SEPA-Lastschriftmandat angenomen am:
        {{ inputForm.get('sepaMandate').get('sepaAcceptedDate').value | date : 'shortDate' }}
      </p>
    </section>
  </section>

  <section>
    <form-row>
      <mat-checkbox
        [disabled]="!canUpdate"
        (change)="changeDifferentInvoiceAddress($event)"
        formControlName="hasDifferentInvoiceContact">
        Abweichende Rechnungsanschrift
      </mat-checkbox>
    </form-row>
  </section>

  <section
    *ngIf="
      inputForm.controls['hasDifferentInvoiceContact'] &&
      inputForm.controls['hasDifferentInvoiceContact'].value == true
    ">
    <h2>Rechnungsanschrift</h2>
    <app-filiation-form
      [inputFormArray]="inputForm.controls['invoiceContact']"
      [id]="null"
      [selectedGisData]="null"
      [disableContractPartner]="true"></app-filiation-form>
  </section>
</form>
